import { parseAndWait } from "@/api/parseJobs.js";

// Actualise une annonce et attend la fin de l'analyse (tâche en arrière-plan côté API)
export async function parse(offer) {
  if (!offer?.url) {
    alert("L'url de cette offre n'est pas valide");
    return null;
  }
  try {
    const outcome = await parseAndWait(offer.url, true);
    if (outcome.status === "Failed") {
      alert(outcome.error || "L'actualisation de l'annonce a échoué.");
    }
    return outcome;
  } catch (error) {
    console.error("Erreur lors de l'actualisation de l'offre :", error);
    return null;
  }
}
